@if (incomeTaxEntity$ | async) {
  <form [formGroup]="formGroup">
    @if (box3OverigeBezittingen.length > 0) {
      <div formArrayName="box3OverigeBezittingen">
        @for (item of box3OverigeBezittingen.controls; track item; let i = $index) {
          <div [formGroupName]="i">
            <div class="row col-auto" style="--bs-gutter-x: 0.5rem;">
              <snelstart-ui-select-form-control [label]="i === 0 ? 'Soort bezit' : ''"
                                                [options]="bezitSoort"
                                                [required]="true"
                                                class="custom-input-250"
                                                formControlName="soort"
              >
              </snelstart-ui-select-form-control>
              <snelstart-ui-text-form-control [label]="i === 0 ? 'Omschrijving bezit' : ''"
                                              class="custom-input-250"
                                              formControlName="omschrijving"
                                              id="omschrijving"
              >
              </snelstart-ui-text-form-control>
              <snelstart-ui-number-form-control [decimals]="0"
                                                [label]="i === 0 ? 'Waarde 1 januari ' + jaar : ''"
                                                [minValue]="0"
                                                [required]="true"
                                                align="right"
                                                class="custom-input-150"
                                                formControlName="bedrag"
                                                id="bedrag"
                                                prefix="€"
              >
              </snelstart-ui-number-form-control>
              <snelstart-ui-button (click)="showDialog(i)"
                                   [disabled]="!heeftOWR"
                                   [class]="i === 0 ? 'pt-3 custom-input-125' : 'custom-input-125'"
                                   [icon]="'plus'"
                                   type="secondary">
                OWR
              </snelstart-ui-button>
              <snelstart-ui-button (click)="verwijderRij(i)"
                                   [class]="i === 0 ? 'firstrowbutton col-auto' : 'col-auto'"
                                   icon="trash"
                                   iconType="light"
                                   id="buttonDeleteKosten"
                                   size="medium"
                                   type="secondary"
              >
              </snelstart-ui-button>
            </div>
          </div>
        }
      </div>
    }
  </form>

  <snelstart-ui-button (click)="addRij()" class="snelstart-ui-button" icon="plus" type="link">
    Bezit toevoegen
  </snelstart-ui-button>

  <snelstart-ui-dialog-definition [(visible)]="dialogVisible"
                                  [title]="getOWRDialogTitel(index)"
                                  id="owrOverigeBezittingen"
                                  size="lg">
    <snelstart-ui-dialog-body>
      <form [formGroup]="formGroup">
        @if (box3OverigeBezittingen.length > 0) {
          <div formArrayName="box3OverigeBezittingen">
            @for (item of box3OverigeBezittingen.controls; track item; let i = $index) {
              <div [formGroupName]="i">
                @if (i === index) {
                  @if (box3OverigeBezittingen.controls[i].get('soort')?.value !== OverigeBezittingSoort.CONTANT_GELD
                    && box3OverigeBezittingen.controls[i].get('soort')?.value !== OverigeBezittingSoort.PREMIEDEPOT
                    && box3OverigeBezittingen.controls[i].get('soort')?.value !== OverigeBezittingSoort.BOUWDEPOT) {
                    <snelstart-ui-number-form-control [decimals]="0"
                                                      [label]="'Waarde op 31 december ' + jaar"
                                                      [minValue]="0"
                                                      [required]="true"
                                                      align="right"
                                                      class="custom-input-275 col-auto"
                                                      formControlName="waardeEindJaar"
                                                      id="bedrag"
                                                      prefix="€"
                    >
                    </snelstart-ui-number-form-control>
                    <snelstart-ui-number-form-control [decimals]="0"
                                                      [label]="'Waarde op 1 januari ' + jaar"
                                                      [minValue]="0"
                                                      [required]="true"
                                                      align="right"
                                                      class="col-auto custom-input-275"
                                                      formControlName="bedrag"
                                                      id="bedrag"
                                                      prefix="€"
                    >
                    </snelstart-ui-number-form-control>
                  }

                  @if (box3OverigeBezittingen.controls[i].get('soort')?.value === OverigeBezittingSoort.CONTANT_GELD) {
                    <snelstart-ui-number-form-control [decimals]="0"
                                                      [required]="true"
                                                      align="right"
                                                      class="custom-input-275 col-auto"
                                                      formControlName="directRendement"
                                                      id="bedrag"
                                                      label="Koerswinst/-verlies"
                                                      prefix="€"
                    >
                    </snelstart-ui-number-form-control>
                  }
                  @if (box3OverigeBezittingen.controls[i].get('soort')?.value === OverigeBezittingSoort.VORDERING) {
                    <snelstart-ui-number-form-control [decimals]="0"
                                                      [label]="'Ontvangen rente in ' + jaar"
                                                      [minValue]="0"
                                                      [required]="true"
                                                      align="right"
                                                      class="custom-input-275 col-auto"
                                                      formControlName="directRendement"
                                                      id="bedrag"
                                                      prefix="€"
                    >
                    </snelstart-ui-number-form-control>
                    <snelstart-ui-number-form-control [decimals]="0"
                                                      [minValue]="0"
                                                      [required]="true"
                                                      align="right"
                                                      class="custom-input-275 col-auto"
                                                      formControlName="toenames"
                                                      id="bedrag"
                                                      label="Verstrekte lening"
                                                      prefix="€"
                    >
                    </snelstart-ui-number-form-control>
                    <snelstart-ui-number-form-control [decimals]="0"
                                                      [label]="'Totaalbedrag aflossingen in ' + jaar"
                                                      [minValue]="0"
                                                      [required]="true"
                                                      align="right"
                                                      class="custom-input-275 col-auto"
                                                      formControlName="afnames"
                                                      id="bedrag"
                                                      prefix="€"
                    >
                    </snelstart-ui-number-form-control>
                  }
                  @if (box3OverigeBezittingen.controls[i].get('soort')?.value === OverigeBezittingSoort.CRYPTO) {
                    <snelstart-ui-number-form-control [decimals]="0"
                                                      [label]="'Totaalbedrag aankopen in ' + jaar"
                                                      [minValue]="0"
                                                      [required]="true"
                                                      align="right"
                                                      class="custom-input-275 col-auto"
                                                      formControlName="toenames"
                                                      id="bedrag"
                                                      prefix="€"
                    >
                    </snelstart-ui-number-form-control>
                    <snelstart-ui-number-form-control [decimals]="0"
                                                      [label]="'Totaalbedrag verkopen in ' + jaar"
                                                      [minValue]="0"
                                                      [required]="true"
                                                      align="right"
                                                      class="custom-input-275 col-auto"
                                                      formControlName="afnames"
                                                      id="bedrag"
                                                      prefix="€"
                    >
                    </snelstart-ui-number-form-control>
                  }
                  @if (box3OverigeBezittingen.controls[i].get('soort')?.value === OverigeBezittingSoort.KAPITAALVERZEKERING) {
                    <snelstart-ui-number-form-control [decimals]="0"
                                                      [label]="'Totaalbedrag betaalde premies in ' + jaar"
                                                      [minValue]="0"
                                                      [required]="true"
                                                      align="right"
                                                      class="custom-input-275 col-auto"
                                                      formControlName="toenames"
                                                      id="bedrag"
                                                      prefix="€"
                    >
                    </snelstart-ui-number-form-control>
                  }
                  @if (box3OverigeBezittingen.controls[i].get('soort')?.value === OverigeBezittingSoort.PREMIEDEPOT) {
                    <snelstart-ui-number-form-control [decimals]="0"
                                                      [label]="'Ontvangen rente in ' + jaar"
                                                      [required]="true"
                                                      align="right"
                                                      class="custom-input-275 col-auto"
                                                      formControlName="directRendement"
                                                      id="bedrag"
                                                      prefix="€"
                    >
                    </snelstart-ui-number-form-control>
                  }
                  @if (box3OverigeBezittingen.controls[i].get('soort')?.value === OverigeBezittingSoort.PERIODIEKE_UITKERING) {
                    <snelstart-ui-number-form-control [decimals]="0"
                                                      [label]="'Totaal betaalde premies in ' + jaar"
                                                      [minValue]="0"
                                                      [required]="true"
                                                      align="right"
                                                      class="custom-input-275 col-auto"
                                                      formControlName="toenames"
                                                      id="bedrag"
                                                      prefix="€"
                    >
                    </snelstart-ui-number-form-control>
                    <snelstart-ui-number-form-control [decimals]="0"
                                                      [label]="'Totaal uitkeringen in ' + jaar"
                                                      [required]="true"
                                                      align="right"
                                                      class="custom-input-275 col-auto"
                                                      formControlName="directRendement"
                                                      id="bedrag"
                                                      prefix="€"
                    >
                    </snelstart-ui-number-form-control>
                  }
                  @if (box3OverigeBezittingen.controls[i].get('soort')?.value === OverigeBezittingSoort.OVERIG) {
                    <snelstart-ui-number-form-control [decimals]="0"
                                                      [label]="'Totaal opbrengsten in ' + jaar"
                                                      [required]="true"
                                                      align="right"
                                                      class="custom-input-275 col-auto"
                                                      formControlName="directRendement"
                                                      id="bedrag"
                                                      prefix="€"
                    >
                    </snelstart-ui-number-form-control>
                    <snelstart-ui-number-form-control [decimals]="0"
                                                      [label]="'Totaal aankopen/stortingen in ' + jaar"
                                                      [minValue]="0"
                                                      [required]="true"
                                                      align="right"
                                                      class="custom-input-275 col-auto"
                                                      formControlName="toenames"
                                                      id="bedrag"
                                                      prefix="€"
                    >
                    </snelstart-ui-number-form-control>
                    <snelstart-ui-number-form-control [decimals]="0"
                                                      [label]="'Totaal verkopen/onttrekking in ' + jaar"
                                                      [minValue]="0"
                                                      [required]="true"
                                                      align="right"
                                                      class="custom-input-275 col-auto"
                                                      formControlName="afnames"
                                                      id="bedrag"
                                                      prefix="€"
                    >
                    </snelstart-ui-number-form-control>
                  }
                  @if (box3OverigeBezittingen.controls[i].get('soort')?.value === OverigeBezittingSoort.BOUWDEPOT) {
                    <snelstart-ui-number-form-control [decimals]="0"
                                                      [label]="'Bijgeschreven rente in ' + jaar"
                                                      [required]="true"
                                                      align="right"
                                                      class="custom-input-275 col-auto"
                                                      formControlName="directRendement"
                                                      id="bedrag"
                                                      prefix="€"
                    >
                    </snelstart-ui-number-form-control>
                  }
                  <snelstart-ui-number-form-control [decimals]="0"
                                                    [disabledControl]="true"
                                                    [label]="'Bijgeschreven rente in ' + jaar"
                                                    [calculate]="getBerekendeWerkelijkRendement(i)"
                                                    align="right"
                                                    class="custom-input-275 col-auto"
                                                    formControlName="berekendRendement"
                                                    id="berekendRendement"
                                                    prefix="€"
                  >
                  </snelstart-ui-number-form-control>
                }
              </div>
            }
          </div>
        }
      </form>
    </snelstart-ui-dialog-body>
    <snelstart-ui-dialog-buttons>
      <snelstart-ui-button btn-x class="me-1" id="cancel" type="secondary">Annuleren
      </snelstart-ui-button>
      <snelstart-ui-button btn-x icon="check" id="save" type="primary">Opslaan
      </snelstart-ui-button>
    </snelstart-ui-dialog-buttons>
  </snelstart-ui-dialog-definition>
}
